import { createAsyncThunk } from "@reduxjs/toolkit";
import { AtualizaValorBonificacaoModel } from "../models/resultadoSorteio/atualizaValorBonificacaoModel";
import { BuscarResumoSorteioModel } from "../models/sorteio/buscarResumoSorteioModel";
import { BuscarSorteioModel } from "../models/sorteio/buscarSorteioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { setModalDeletarSorteio, setPageSorteio } from "../redux/slices/sorteio/sorteioSlice";
import api from "../util/api";
import { toastError, toastSucess } from "../util/toast";

export const cadastrarSorteio = createAsyncThunk("/Sorteio/CadastrarSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Sorteio/CadastrarSorteio/", payload.value);
    toastSucess("O sorteio foi cadastrado com sucesso");
    dispatch(setPageSorteio("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarSorteio = createAsyncThunk("/Sorteio/BuscarSorteio", async (args: BuscarSorteioModel) => {
  try {
    const data = await api.get("/Sorteio/BuscarSorteio", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarResumoSorteio = createAsyncThunk("/Sorteio/BuscarResumoSorteio", async (args: BuscarResumoSorteioModel) => {
  try {
    const data = await api.get("/Sorteio/BuscarResumoSorteio", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarSorteio = createAsyncThunk("/Sorteio/ListarSorteio", async (idEmpresas: string | null) => {
  try {
    const data = await api.get("/Sorteio/ListarSorteio", {
      params: { idEmpresas: idEmpresas },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarSorteio = createAsyncThunk("/Sorteio/AtualizarSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Sorteio/AtualizarSorteio/", payload.value);
    toastSucess("O sorteio foi atualizado com sucesso");
    dispatch(setPageSorteio("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarResumoSorteio = createAsyncThunk("/Sorteio/atualizarResumoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Sorteio/atualizarResumoSorteio/", payload.value);
    toastSucess("O sorteio foi atualizado com sucesso");
    dispatch(setPageSorteio("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarValorBonificacao = createAsyncThunk("/Sorteio/AtualizaValorBonificacao", async (payload: AtualizaValorBonificacaoModel, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Sorteio/AtualizaValorBonificacao", payload);
    toastSucess("Valor de bonificação atualizado com sucesso");
    dispatch(setLoading(false));
    return true;
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response?.data?.Message ?? "Erro ao atualizar o valor de bonificação");
    throw error;
  }
});

export const deletarSorteio = createAsyncThunk("/Sorteio/DeletarSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Sorteio/DeletarSorteio", {
      params: { id: payload.value },
    });
    toastSucess("O sorteio foi removido com sucesso");
    dispatch(setModalDeletarSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
